export default __webpack_public_path__ + "static/media/section3-img1.77f90663.png";